import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useStore } from "../store/useStore";

const Stopwatch = ({ timerVisible, onTimeExceeded }) => {
  const {
    assignappId,
    applicationStartTime,
    setCloseApplication,
    setShowCloseApplicationModal,
    showCloseApplicationModal,
    userHasClosedApplicationModal,
    applicacionData,
  } = useStore();

  const isTimed = applicacionData?.timed ?? true;

  const startTime = Math.floor(applicationStartTime * 1000);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [hasExceededWarning, setHasExceededWarning] = useState(false);

  // Extrae los tiempos desde applicacionData
  const timeWarning = applicacionData?.time_warning_minutes ?? 120;

  const timeCloseWarning = applicacionData?.time_close_warning_minutes ?? 150;

  const timeAutoClose = applicacionData?.time_auto_close_minutes ?? 165;

  const isReactivated = applicacionData?.reactivated === true;

  useEffect(() => {
    let interval = null;

    if (timerVisible && isTimed) {
      interval = setInterval(() => {
        const now = Date.now();
        setCurrentTime(now);

        if (startTime && !isReactivated) {
          const elapsedMs = now - startTime;
          const elapsedMinutes = elapsedMs / (60 * 1000);

          // Tiempo de advertencia (rojo)
          if (elapsedMinutes >= timeWarning && !hasExceededWarning) {
            setHasExceededWarning(true);
            onTimeExceeded(true);
          }

          // Advertencia de cierre
          if (elapsedMinutes >= timeCloseWarning && elapsedMinutes < timeAutoClose && !showCloseApplicationModal && !userHasClosedApplicationModal) {
            setShowCloseApplicationModal(true);
          }

          // Cierre automático
          if (elapsedMinutes >= timeAutoClose) {
            setCloseApplication(true);
          }
        }
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [
    assignappId,
    hasExceededWarning,
    setCloseApplication,
    setShowCloseApplicationModal,
    showCloseApplicationModal,
    userHasClosedApplicationModal,
    startTime,
    timerVisible,
    timeWarning,
    timeCloseWarning,
    timeAutoClose,
    onTimeExceeded,
    isTimed,
    isReactivated,
  ]);

  const elapsedTime = startTime ? currentTime - startTime : 0;

  const hours = ("0" + Math.floor((elapsedTime / 3_600_000) % 24)).slice(-2);

  const minutes = ("0" + Math.floor((elapsedTime / 60_000) % 60)).slice(-2);

  const seconds = ("0" + Math.floor((elapsedTime / 1_000) % 60)).slice(-2);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        fontSize: {
          xs: "1rem",
          sm: "1.125rem",
          md: "1.25rem",
        },

        lineHeight: 1.2,
        fontWeight: 500,
        fontVariantNumeric: "tabular-nums",
        fontFeatureSettings: '"tnum"',

        minWidth: {
          xs: 78,
          sm: 88,
          md: 96,
        },
      }}
    >
      <Box component="span">{hours}</Box>
      <Box component="span" sx={{ mx: 0.25 }}>
        :
      </Box>
      <Box component="span">{minutes}</Box>
      <Box component="span" sx={{ mx: 0.25 }}>
        :
      </Box>
      <Box component="span">{seconds}</Box>
    </Box>
  );
};

export default Stopwatch;
